import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const vaccinesStartRequest = () => {
  return {
    type: 'VACCINES_START_REQUEST'
  };
};

export const vaccinesEndRequest = () => {
  return {
    type: 'VACCINES_END_REQUEST'
  };
};

export const getAllVaccinesSuccess = ({ data }) => {
  return {
    type: 'VACCINES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllVaccinesError = error => {
  return {
    type: 'VACCINES_GET_ALL_ERROR',
    payload: error
  };
};

export const addVaccinesSuccess = ({ data }) => {
  return {
    type: 'VACCINES_ADD_SUCCESS',
    payload: data
  };
};

export const addVaccinesError = error => {
  return {
    type: 'VACCINES_ADD_ERROR',
    payload: error
  };
};

export const editVaccinesSuccess = ({ data }) => {
  return {
    type: 'VACCINES_EDIT_SUCCESS',
    payload: data
  };
};

export const editVaccinesError = error => {
  return {
    type: 'VACCINES_EDIT_ERROR',
    payload: error
  };
};

export const removeVaccinesSuccess = id => {
  return {
    type: 'VACCINES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeVaccinesError = error => {
  return {
    type: 'VACCINES_REMOVE_ERROR',
    payload: error
  };
};

export const vaccinesModifyStore = ({ data }) => {
  return {
    type: 'VACCINES_MODIFY_STORE',
    payload: data
  };
};

export const addVaccines = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(vaccinesStartRequest());
      const response = await api().post('/api/vaccines', data);
      dispatch(addVaccinesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'vaccines',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addVaccinesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(vaccinesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllVaccines = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(vaccinesStartRequest());
      const response = await api().get('/api/vaccines', { params });
      dispatch(getAllVaccinesSuccess(response));
    } catch (err) {
      dispatch(getAllVaccinesError(err));
    } finally {
      dispatch(vaccinesEndRequest());
    }
  };
};

export const editVaccines = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(vaccinesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(vaccinesStartRequest());
      const id = data._id;
      const response = await api().put('/api/vaccines/' + id, data);
      dispatch(editVaccinesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'vaccines',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/vaccines'));
      }
    } catch (err) {
      dispatch(editVaccinesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeVaccines = id => {
  return async dispatch => {
    try {
      dispatch(vaccinesStartRequest());
      await api().delete('/api/vaccines/' + id);
      dispatch(removeVaccinesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'vaccines',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Vacina removida com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeVaccinesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover vacina.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(vaccinesEndRequest());
    }
  };
};

export const restoreVaccines = data => {
  return async dispatch => {
    try {
      dispatch(vaccinesStartRequest());
      const id = data._id;
      const response = await api().put('/api/vaccines/' + id, data);
      dispatch(editVaccinesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'vaccines',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Vacina restaurada com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editVaccinesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar vacina.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(vaccinesEndRequest());
    }
  };
};
